import { useLockedSubcategoryModal } from "@areahub/ui/components/modal/pro-plan/locked-subcategory-modal";
import {
  Box,
  Slider,
  SliderProps,
  SliderThumb,
  SliderTrack,
} from "@chakra-ui/react";
import { FaLock } from "react-icons/fa";
import { ProgressStatCardProps } from "./progress-stat-card-props";

export const ProgressBarLocked = ({
  title,
  from,
  ...rest
}: Pick<ProgressStatCardProps, "title" | "from"> & SliderProps) => {
  const openLockedSubcategoryModal = useLockedSubcategoryModal();
  return (
    <Slider
      aria-label={title + "-metered-value"}
      defaultValue={50}
      isReadOnly
      {...rest}
    >
      <SliderTrack
        bgGradient="linear(to-r, white, blueGray.600)"
        borderRadius="lg"
      />
      <SliderThumb boxSize={4} bg="white" borderColor="blueGray.600">
        <Box
          color="blueGray.600"
          h="2"
          w="2"
          as={FaLock}
          onClick={() => {
            from !== "report-page" ? openLockedSubcategoryModal(title) : false;
          }}
        />
      </SliderThumb>
    </Slider>
  );
};
